// Sign-up's checks (RegisterModal, F18), kept apart so they can be tested on their own.

// One part of a name: letters from any language (Niña, Peñaflor, José, Nguyễn), with dots,
// apostrophes and hyphens inside it (Ma., O'Neil, Jean-Pierre). It starts with a letter.
const NAME_PART = /^[\p{L}\p{M}][\p{L}\p{M}.'’-]*$/u;

export const NAME_HINT = "Type your first and last name, like Juan Dela Cruz.";

/** First and last name at least, in any alphabet. */
export const isValidFullName = (fullName) => {
  const parts = String(fullName || "").trim().split(/\s+/).filter(Boolean);
  return parts.length >= 2 && parts.every((part) => NAME_PART.test(part));
};

/** "nina@gmail.com" → "n•••@gmail.com": enough to recognise it, not to read it over a shoulder. */
export const maskEmail = (email) => {
  const [name, domain] = String(email || "").trim().split("@");
  if (!domain) return String(email || "");
  return `${name.slice(0, 1)}•••@${domain}`;
};
